import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Slide,
} from "@material-ui/core";
import AutoCompletePrestadorPresupuesto from "../../UI/AutoCompletePrestadorPresupuesto";
import { TIPOS_PRESUPUESTO } from "../../../../utils/constants";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalModificarPrestador = (props) => {
    const { formValues } = props;
    const [value, setValue] = useState(formValues);

    const guardarPrestador = () => {
        props.modificar(value)
        props.close();
    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={props.open}
            onClose={props.close}
            TransitionComponent={Transition}
            keepMounted
        >
            <DialogTitle>Modificar Prestador</DialogTitle>
            <DialogContent>
                <Grid container style={{ justifyContent: 'center' }} spacing={2}>
                    <Grid item xs={8} md={8}>
                        <AutoCompletePrestadorPresupuesto
                            autoCompleteValue={
                                value.idTipoPresupuesto === TIPOS_PRESUPUESTO.CON_CONTRATO
                                    ? { prestadorCuit: value.cuitPrestador,
                                        prestadorNombreApellido: value.nombrePrestador,
                                        efectorFacturacionRazonSocial: "",
                                        efectorFacturacionCuit: "", }
                                    : null
                            }
                            onChangeHandler={(value) => {
                                if (value)
                                   setValue(value)
                                else
                                    setValue([])
                            }}
                        />
                    </Grid>
                </Grid>
                <div
                    style={{
                        marginTop: "2rem",
                        marginBottom: "1rem",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly",
                    }}
                >
                    <Button variant="contained" color="primary" onClick={props.close}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={guardarPrestador}
                    >
                        Confirmar
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}
